module.exports = __webpack_public_path__ + "static/ummslogo-8f5a6f09068eca333e4a0f6c6d572183.svg";